<mat-menu
    #menu="matMenu"
    class="treeslo-grid-action-menu-panel"
    [overlapTrigger]="false"
    xPosition="after"
    yPosition="below">
    @for (action of actions; track trackAction($index, action)) {
    @if (hasNestedMenu(action)) {
    <button
        mat-menu-item
        type="button"
        [matMenuTriggerFor]="subMenu.menu"
        [disabled]="host.isActionDisabled(action, row)"
        [matTooltip]="host.getActionTooltip(action, row) | translate"
        [matTooltipDisabled]="!host.getActionTooltip(action, row)">
        <span class="treeslo-grid-menu-item">
            @if (action.icon) {
            <i-tabler [name]="action.icon" class="action-icon"></i-tabler>
            }
            @if (host.getActionMenuLabel(action); as menuLabel) {
            <span>{{ menuLabel | translate }}</span>
            }
        </span>
    </button>
    <app-treeslo-grid-action-menu
        #subMenu
        [actions]="getNestedActions(action)"
        [row]="row"
        [rowIndex]="rowIndex"
        [host]="host" />
    } @else if (host.isActionVisible(action, row)) {
    <button
        mat-menu-item
        type="button"
        (click)="onLeafClick(action, $event)"
        [disabled]="host.isActionDisabled(action, row)"
        [matTooltip]="host.getActionTooltip(action, row) | translate"
        [matTooltipDisabled]="!host.getActionTooltip(action, row)">
        <span class="treeslo-grid-menu-item">
            @if (action.icon) {
            <i-tabler [name]="action.icon" class="action-icon"></i-tabler>
            }
            @if (host.getActionMenuLabel(action); as menuLabel) {
            <span>{{ menuLabel | translate }}</span>
            }
        </span>
    </button>
    }
    }
</mat-menu>
